import React from "react";

export function FileUploadInput({ inputRef, onChange }) {
  const handleOnChange = (event) => {
    onChange(event.target.files[0]);
    inputRef.current.value = "";
  };

  return (
    <input
      type="file"
      onChange={handleOnChange}
      ref={inputRef}
      accept="application/pdf, image/*"
      style={{ display: "none" }}
    />
  );
}
